import React, { Component } from 'react'
import * as R from 'ramda'
import { connect } from 'react-redux'
import { routerActions } from 'react-router-redux'

import {List, ListItem} from 'material-ui/List'

import dataActions from 'actions/dataActions'
import { doc, dirtyRead } from 'selectors/common'
import { objectTerms } from 'selectors/lease'
import TermCard from './TermCard'

let select = dirtyRead(
	(state, props) => {
		return ({
			terms: objectTerms(state, props)
		})
	}
)

export class TermList extends Component {
	render() {
		let { props } = this
	    return(
			<List
				style={{
					backgroundColor: "transparent"
					, paddingTop: "0"
				}}
			>
				{props.terms &&
					R.map(term => <TermCard termID={term._id}  term={term} />, props.terms)
				}
			</List>
	    )
	}
}
export default connect(select, R.mergeAll([dataActions, routerActions]))(TermList)



// WEBPACK FOOTER //
// ./src/routes/landlord/leaseForm/TermList.js